import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

import UserAvatar from 'components/UserAvatar';
import { AvatarShape } from 'entities';

class UserSettingsAvatar extends Component {

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.onClick(this.props.avatar.id);
  }

  render() {
    const className = classnames(
      "option",
      {
        'is-selected': this.props.isSelected
      }
    );

    return (
      <div className={className} onClick={this.handleClick}>
        <UserAvatar size="large" imageUrl={this.props.avatar.url} />
      </div>
    );
  }
}

UserSettingsAvatar.propTypes = {
  avatar: AvatarShape,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func
};

export default UserSettingsAvatar;




/** WEBPACK FOOTER **
 ** ./src/members/Main/UserSettings/UserSettingsChangeAvatar/UserSettingsAvatar/index.js
 **/